// Shared easing curves so every animation on the site moves the same way.
export const easeOutExpo = [0.16, 1, 0.3, 1];
export const easeInOutQuart = [0.76, 0, 0.24, 1];
